var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProyecto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.93,477.87H128a8.53,8.53,0,0,0-8.53,8.53v17.07a8.53,8.53,0,0,0,17.06,0v-8.54h230.4a8.53,8.53,0,1,0,0-17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.73,213.33a8.55,8.55,0,0,0,8.54,8.54H230.4a8.54,8.54,0,0,0,8.53-8.54v-51.2a8.53,8.53,0,0,0-8.53-8.53H196.27a8.54,8.54,0,0,0-8.54,8.53v51.2Zm17.07-42.66h17.07V204.8H204.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.93,102.4H8.53A8.53,8.53,0,0,0,0,110.93V281.6a8.54,8.54,0,0,0,17.07,0V119.47h93.86a8.54,8.54,0,1,0,0-17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.6,418.13a8.54,8.54,0,0,0,8.53,8.54h34.14a8.54,8.54,0,0,0,8.53-8.54v-51.2a8.53,8.53,0,0,0-8.53-8.53H418.13a8.53,8.53,0,0,0-8.53,8.53Zm17.07-42.66h17.06V409.6H426.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.67,307.2C.49,307.2,0,417,0,418.13a42.75,42.75,0,0,0,34.13,41.81v43.53a8.54,8.54,0,0,0,17.07,0V459.94a42.74,42.74,0,0,0,34.13-41.81C85.33,417,84.85,307.2,42.67,307.2Zm0,136.53a25.62,25.62,0,0,1-25.6-25.6c0-42.51,11.42-93.86,25.6-93.86s25.6,51.35,25.6,93.86A25.63,25.63,0,0,1,42.67,443.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.87,256H59.73a8.53,8.53,0,0,0-8.53,8.53V281.6a8.54,8.54,0,0,0,17.07,0v-8.53H85.33v42.66a8.54,8.54,0,1,0,17.07,0v-51.2A8.53,8.53,0,0,0,93.87,256Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M418.13,221.87h34.14a8.54,8.54,0,0,0,8.53-8.54v-51.2a8.53,8.53,0,0,0-8.53-8.53H418.13a8.53,8.53,0,0,0-8.53,8.53v51.2A8.54,8.54,0,0,0,418.13,221.87Zm8.54-51.2h17.06V204.8H426.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.87,153.6H59.73a8.53,8.53,0,0,0-8.53,8.53v51.2a8.54,8.54,0,0,0,8.53,8.54H93.87a8.54,8.54,0,0,0,8.53-8.54v-51.2A8.53,8.53,0,0,0,93.87,153.6Zm-8.54,51.2H68.27V170.67H85.33V204.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.07,213.33a8.54,8.54,0,0,0,8.53,8.54h34.13a8.55,8.55,0,0,0,8.54-8.54v-51.2a8.54,8.54,0,0,0-8.54-8.53H281.6a8.53,8.53,0,0,0-8.53,8.53v51.2Zm17.06-42.66H307.2V204.8H290.13V170.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M503.47,102.4H401.07a8.54,8.54,0,1,0,0,17.07h93.86v342.9a25.12,25.12,0,0,0-8.53-1.57,25.65,25.65,0,0,0-4.38.38,34.08,34.08,0,0,0-59.5,0A25.6,25.6,0,1,0,418.14,512H486.4A25.64,25.64,0,0,0,512,486.4V110.93A8.53,8.53,0,0,0,503.47,102.4ZM486.4,494.93H418.13a8.53,8.53,0,1,1,4.63-15.67A8.54,8.54,0,0,0,435.7,474a17,17,0,0,1,33.14,0,8.48,8.48,0,0,0,5.1,6,8.58,8.58,0,0,0,7.84-.73c5.55-3.59,13.15.8,13.15,7.14A8.54,8.54,0,0,1,486.4,494.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.6,119.47h34.13a8.55,8.55,0,0,0,8.54-8.54V59.73a8.54,8.54,0,0,0-8.54-8.53H281.6a8.53,8.53,0,0,0-8.53,8.53v51.2A8.54,8.54,0,0,0,281.6,119.47Zm8.53-51.2H307.2V102.4H290.13V68.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.07,315.73a8.54,8.54,0,0,0,8.53,8.54h34.13a8.55,8.55,0,0,0,8.54-8.54v-51.2a8.54,8.54,0,0,0-8.54-8.53H281.6a8.53,8.53,0,0,0-8.53,8.53v51.2Zm17.06-42.66H307.2V307.2H290.13V273.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.27,119.47H230.4a8.54,8.54,0,0,0,8.53-8.54V59.73a8.53,8.53,0,0,0-8.53-8.53H196.27a8.54,8.54,0,0,0-8.54,8.53v51.2A8.55,8.55,0,0,0,196.27,119.47Zm8.53-51.2h17.07V102.4H204.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.94,412.08a8.53,8.53,0,1,0,12.12,0A8.94,8.94,0,0,0,249.94,412.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.73,315.73a8.55,8.55,0,0,0,8.54,8.54H230.4a8.54,8.54,0,0,0,8.53-8.54v-51.2A8.53,8.53,0,0,0,230.4,256H196.27a8.54,8.54,0,0,0-8.54,8.53v51.2Zm17.07-42.66h17.07V307.2H204.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.67,366.93a8.54,8.54,0,0,0,8.53,8.54h25.6v76.8a8.54,8.54,0,0,0,17.07,0v-76.8h68.26v76.8a8.54,8.54,0,0,0,17.07,0v-76.8h25.6a8.54,8.54,0,0,0,0-17.07H179.2A8.53,8.53,0,0,0,170.67,366.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.6,315.73a8.54,8.54,0,0,0,8.53,8.54h34.14a8.54,8.54,0,0,0,8.53-8.54v-51.2a8.53,8.53,0,0,0-8.53-8.53H418.13a8.53,8.53,0,0,0-8.53,8.53Zm17.07-42.66h17.06V307.2H426.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.93,0H145.07a8.54,8.54,0,0,0-8.54,8.53V452.27a8.54,8.54,0,0,0,17.07,0V17.07H358.4v435.2a8.54,8.54,0,0,0,17.07,0V8.53A8.54,8.54,0,0,0,366.93,0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProyecto);
export default __webpack_public_path__ + "static/media/Proyecto.8a99323c557a08bf1bf5f7fd86a2dcb7.svg";
export { ForwardRef as ReactComponent };